// Copyright (c) StrangeBee 2023

import Form, { FormInstance } from 'antd/lib/form';
import React, { ReactElement } from 'react';
import SerieForm from './SerieForm';
import ProvidedWidgetFormFilter from '@Organisms/Dashboard/WidgetManage/WidgetFormFilter/ProvidedWidgetFormFilter';
import { THForm } from '@Molecules/THForm/THForm';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { ICONS } from '@Constants/iconsApp';
import { entitiesToExclude } from '@Constants/dashboard';

import './SerieCard.scss';

type FieldType = {
    key: number;
    name: number;
};

interface SerieCardProps {
    field: FieldType;
    textField?: boolean;
    lineField?: boolean;
    remove: (index: number) => void;
    index: number;
    form: FormInstance;
    counterField?: boolean;
}

const SerieCard = ({
    field,
    textField,
    remove,
    index,
    form,
    lineField,
    counterField,
}: SerieCardProps): ReactElement => {
    const { key, name } = field;

    const serieEntity = Form.useWatch(['series', index, 'entity'], form);
    const entity = Form.useWatch(['entity'], form);

    return (
        <div key={key} className="serie-card">
            <div className="serie-card__form">
                <SerieForm
                    entity={serieEntity || entity}
                    form={form}
                    index={index}
                    textField={textField}
                    lineField={lineField}
                    counterField={counterField}
                    entitiesToExclude={lineField || textField ? entitiesToExclude : []}
                />

                <THButton color="red" type="link" onClick={remove.bind(null, name)} icon={<ICONS.DeleteIcon />} />
            </div>

            <div className="serie-filters">
                <THForm.Item name={[index, 'filters']} className="form-item no-value">
                    <ProvidedWidgetFormFilter entity={serieEntity || entity} />
                </THForm.Item>
            </div>
        </div>
    );
};

export default SerieCard;
